//// import { Observable } from 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IEvoSystem } from '../models/AuthModels';
import { IUserDetail } from '../models/UserDetailModel';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { LookupEnvironmentService } from './lookup-environment.service';


@Injectable()
export class SessionService {
	constructor(
		private http: HttpClient,
		private cookieSvc: CookieService,
		private env: LookupEnvironmentService
	) { }

	// Public Methods
	keepAlive(): Observable<object> {
		return this.http.post('api/auth/keepalive', null);
	}

	logout(proceed_to_login = false) {
		const url = 'api/auth/Logout';
		this.http.post(url, null).toPromise().then(
			result => {
				this.redirect(proceed_to_login);
			},
			error => {
				this.redirect(proceed_to_login);
			}
		);
		this.cookieSvc.delete("userName");
	}

	// Redirect to shared authWeb application with a refURL for
	//   return after a subsequent successful login
	private async redirect(proceed_to_login: boolean) {
		// redirect to the shared login application
		const authHashPath = proceed_to_login ? '#/login' : '#/logout';
		let referUrlSearch = '';
		if (proceed_to_login) {
			let href = window.location.href;
			href = href.replace(/logout\/.*$/, '');
			referUrlSearch = '?referUrl=' + btoa(href);
		}

		this.env.FetchConfig_CacheFree().then(config => {
			console.log("config:", config);
			const authWebURL = config['authWebURL'];
			const authUrl = authWebURL ? authWebURL : '/AuthWeb/';
			console.warn("Logging out of SP redirecting to...", authUrl + authHashPath + referUrlSearch);
			window.location.href = authUrl + authHashPath + referUrlSearch;
		});
	}

	getUserAccess() {
		const url = 'api/auth/getuseraccess';
		return this.http.get<Array<IEvoSystem>>(url);
	}
	getUserDetail() {
		const url = 'api/auth/getuserdetail';
		var result = this.http.get<IUserDetail>(url);
		result.subscribe(p=>{
			this.cookieSvc.set("userName",p.FirstName+' '+p.LastName);
		});
		return result;
	}
}
